var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-container"},[_c('Breadcrumb',{attrs:{"items":_vm.breadCrumbs}}),_c('v-container',{staticClass:"profile-section",attrs:{"fluid":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }